import React from 'react'
import { useSelector } from 'react-redux'
import { ratingListLabel9 } from 'keys/rating'
import DistributionBar, { splitWidths } from './DistributionBar'
import { tierLegendDescriptions } from '../constants'

// כרטיס צר מדי לא מציג את שורת התיאור
const NOTE_MIN_WIDTH_PCT = 30

const Slide4ReadingResults = ({ data }) => {
    const { brokenDisplay } = useSelector(state => state.general)
    const { tiers, readersPct, strugglingPct, strugglingCount, readersCount} = data

    const { readers: readersWidth, struggling: strugglingWidth } = splitWidths(tiers)

    return (
        <div className='results-layout'>
            <div className='labeled-row'>
                <div className='row-side-label'>
                    {'חלוקה כללית בין '}
                    <span style={{ color: '#7FAE1A' }}>{'קוראים'}</span>
                    {' לבין '}
                    <span style={{ color: '#FF4D4D' }}>{'מתקשים בקריאה'}</span>
                </div>
                <div className='macro-split'>
                    <div className='macro-card' style={{ width: `${readersWidth}%`, borderColor: '#7FAE1A', backgroundColor: '#FAFEF6' }}>
                        <div className='macro-pct' style={{ color: '#7FAE1A' }}>{`${readersPct}%`}</div>
                        <div style={{fontSize: '14px'}} ><span className={`${brokenDisplay && 'blurred2'}`}>{readersCount}</span>{' תלמידים'}</div>
                        <div className='macro-label'>
                            <span className='macro-pipe' style={{ backgroundColor: '#7FAE1A' }} />
                            {'קוראים'}
                        </div>
                        {readersWidth >= NOTE_MIN_WIDTH_PCT &&
                            <div className='macro-note'>
                                {'מצויים בדירוג גבוה או בטווח המצופה לשכבת הגיל, או קרובים אליו.'}
                            </div>}
                    </div>
                    <div className='macro-card' style={{ width: `${strugglingWidth}%`, borderColor: '#FF4D4D', backgroundColor: '#FFF5F5' }}>
                        <div className='macro-pct' style={{ color: '#FF4D4D' }}>{`${strugglingPct}%`}</div>
                        <div style={{fontSize: '14px'}} ><span className={`${brokenDisplay && 'blurred2'}`}>{strugglingCount}</span>{' תלמידים'}</div>
                        <div className='macro-label'>
                            <span className='macro-pipe' style={{ backgroundColor: '#FF4D4D' }} />
                            {'מתקשים בקריאה'}
                        </div>
                        {strugglingWidth >= NOTE_MIN_WIDTH_PCT &&
                            <div className='macro-note'>
                                {'מצויים מתחת לטווח המצופה וזקוקים למענה.'}
                            </div>}
                    </div>
                </div>
            </div>

            <div className='labeled-row'>
                <div className='row-side-label'>{'התפלגות לפי דירוגי הקריאה'}</div>
                <div className='labeled-row-content'>
                    <DistributionBar tiers={tiers} showBrackets showDescriptions={false} blurred={brokenDisplay} />
                </div>
            </div>

            <div className='results-legend'>
                <div className='legend-title'>{'מקרא'}</div>
                {tiers.map(tier => (
                    <div key={tier.index} className='legend-item'>
                        <span className='legend-swatch' style={{ backgroundColor: tier.color }} />
                        <div className='legend-text'>
                            <span style={{ color: tier.textColor }}>{ratingListLabel9[tier.index - 1]}</span>
                            {` • ${tier.percentage}% • `}
                            <span className={`${brokenDisplay && 'blurred2'}`}>{tier.count.toLocaleString()}</span>
                            {` תלמידים ${tierLegendDescriptions[tier.index - 1]}`}
                        </div>
                    </div>
                ))}
            </div>
        </div>
    )
}

export default Slide4ReadingResults
